import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxWheelModule } from 'ngx-wheel';

import { DrawRoutingModule } from './draw-routing.module';
import { DrawComponent } from './draw.component';

import { DrawService } from './draw.service';
@NgModule({
    imports: [FormsModule, CommonModule, ReactiveFormsModule, NgxWheelModule, DrawRoutingModule],
    declarations: [DrawComponent],
    exports: [],
    providers: [DrawService]
})
export class DrawModule { }
